import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { MatchesService } from '../../services/matches.service';
import { SidenavService } from '../../services/sidenav.service';
import { SnackbarService } from '../../services/snackbar.service';
import { TeamsService } from '../../services/teams.service';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'app-champion-and-pichichi',
  templateUrl: './champion-and-pichichi.component.html',
  styleUrls: ['./champion-and-pichichi.component.scss'],
  standalone: false,
})
export class ChampionAndPichichiComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  sidenav: MatSidenav;
  user: any;
  userId: string;
  loggedUser: any;
  isAdmin: boolean;
  currentTimestamp: number;
  firstRoundIniTimestamp: number;
  teams: any[];
  isMe: boolean = false;

  pichichiTeamId: string | null = null;
  pichichiPlayers: any[] = [];
  pichichiPlayersLoading: boolean = false;

  private rounds: any[];

  constructor(
    private sidenavService: SidenavService,
    private usersService: UsersService,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService,
    private authService: AuthService,
    private matchesService: MatchesService,
    private teamsService: TeamsService,
    private apiService: ApiService,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
    this.loggedUser = this.authService.getUser();
    this.currentTimestamp = new Date().getTime() / 1000;
  }

  async ngOnInit() {
    if (!this.loggedUser?._id) {
      this.router.navigate(['/login']);
      return;
    }

    this.rounds = await this.matchesService.getRounds();
    this.teams = await this.teamsService.getList();
    this.firstRoundIniTimestamp = this.rounds[0].iniTimestamp;
    this.userId = this.route.snapshot.params['id'];
    this.isAdmin = this.authService.isAdmin();

    if (this.userId) {
      if (
        this.userId !== this.loggedUser._id &&
        this.currentTimestamp < this.firstRoundIniTimestamp
      ) {
        this.snackbar.info(
          'No puedes ver los resultados de los demás hasta que no se haya iniciado la ronda',
        );
        return;
      }
      this.user = await this.usersService.get(this.userId);
    } else {
      this.user = this.loggedUser;
    }

    if (!this.user.jokers) {
      this.user.jokers = { champion: false, pichichi: false, matches: [] };
    }

    if (!this.user.champion?._id) {
      this.user.champion = { _id: null };
    }

    if (!this.user.pichichi) {
      this.user.pichichi = null;
    }

    // Pre-load players if pichichi is already set
    if (this.user.pichichi) {
      try {
        const player: any = await this.apiService.request(
          `/players/${this.user.pichichi}`,
          'GET',
        );
        const teamId =
          player?.team?._id ?? player?.team ?? player?.teamId ?? null;
        if (teamId) {
          this.pichichiTeamId = teamId;
          this.pichichiPlayers = await this.apiService.request(
            `/teams/${teamId}/players`,
            'GET',
          );
        }
      } catch {
        // pichichi player not found — leave selectors empty
      }
    }

    this.isMe = this.user._id === this.loggedUser._id;
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  getSelectedChampionFlag(): string | null {
    if (!this.user?.champion?._id || !this.teams) return null;
    return (
      this.teams.find((t) => t._id === this.user.champion._id)?.flag ?? null
    );
  }

  getPichichiTeamFlag(): string | null {
    if (!this.pichichiTeamId || !this.teams) return null;
    return this.teams.find((t) => t._id === this.pichichiTeamId)?.flag ?? null;
  }

  getSelectedPlayerName(): string | null {
    if (!this.user?.pichichi || !this.pichichiPlayers.length) return null;
    return (
      this.pichichiPlayers.find((p) => p._id === this.user.pichichi)?.name ??
      null
    );
  }

  async onPichichiTeamChange(teamId: string) {
    this.pichichiTeamId = teamId;
    this.user.pichichi = null;
    this.pichichiPlayersLoading = true;
    try {
      this.pichichiPlayers = teamId
        ? await this.apiService.request(`/teams/${teamId}/players`, 'GET')
        : [];
    } catch {
      this.pichichiPlayers = [];
    } finally {
      this.pichichiPlayersLoading = false;
    }
  }

  update() {
    const payload = {
      ...this.user,
      champion: this.user.champion?._id ? this.user.champion : null,
    };
    this.blockUI.start();
    this.usersService
      .update(payload)
      .then(() => {
        this.blockUI.stop();
        this.snackbar.success('Los datos se han actualizado correctamente.');
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackbar.error(error.message);
      });
  }
}
